import { http } from '@pendo/http';

export function fetchAllThemes () {
    return http.get('/api/s/_SID_/theme?all=true').then((res) => res.data);
}

export function fetchOrganizationThemes (orgId, subId) {
    return http.get(`/api/organization/${orgId}/resources/theme`, { params: { subId } }).then((res) => res.data);
}

export function createTheme (theme) {
    return http.post('/api/s/_SID_/theme', theme).then((res) => res.data);
}

export function updateTheme (theme) {
    return http.put(`/api/s/_SID_/theme/${theme.id}`, theme).then((res) => res.data);
}

export function deleteTheme (id) {
    return http.delete(`/api/s/_SID_/theme/${id}`);
}
